jQuery(document).foundation();

jQuery(window).on('scroll', function() {
	jQuery('#header').removeClass('unscrolled');
});

let mybutton = document.getElementById("scrollTop");
window.onscroll = function() { scrollFunction() };

function scrollFunction() {
  if (document.body.scrollTop > 1000 || document.documentElement.scrollTop > 1000) {
    mybutton.style.display = "block";
  } else {
    mybutton.style.display = "none";
  }
}

(function($){
    $.fn.shuffle = function() {
 
        var allElems = this.get(),
            getRandom = function(max) {
                return Math.floor(Math.random() * max);
            },
            shuffled = $.map(allElems, function(){
                var random = getRandom(allElems.length),
                    randEl = $(allElems[random]).clone(true)[0];
                allElems.splice(random, 1);
                return randEl;
           });
 
        this.each(function(i){
            $(this).replaceWith($(shuffled[i]));
        });
 
        return $(shuffled);
 
    };
})(jQuery);

jQuery(document).ready(function(){
  jQuery("#latest-posts li").shuffle();
  jQuery("#latest-posts").owlCarousel({
      loop: true,
      nav: true,
      nestedItemSelector: 'wp-block-latest-posts__list > li',
      itemElement: 'ul',
      responsiveClass: true,
      responsive: {
          0: {
            items: 1,
            margin: 20
          },

          540: {
            items: 2,
            margin: 50
          }
      }
  });
});